import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { GiftCardStepService } from '../services/giftcard-step.service';

@Injectable()
export class GiftcardOrdedrGuard implements CanActivate {

  constructor(
    private router: Router,
    private giftCardStepService: GiftCardStepService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (this.giftCardStepService.isOrderAvailable) {
      return true;
    }

    this.router.navigate(['giftcard']);

    return false;
  }
}
